import { formatRelative } from 'date-fns';
import id from 'date-fns/locale/id';

const StdRelativeDateTimeFormat = ({ text }) =>
    text ? formatRelative(Date.parse(text.replace(' ', 'T')), new Date(), { locale: id }) : null;
export default StdRelativeDateTimeFormat;
